import React from 'react';
import {ForecastQueryRenderer} from '../../../../../../../ForecastQueryRenderer';
import {RelayProps} from '../../../../../../../relay-helpers/TSRelayConverter';
import TimeOffModalCreate, {TimeOffModalCreateProps, TimeOffModalCreateQuery} from '../TimeOffModalCreate';
import type {TimeOffModalCreate_viewer} from '../__generated__/TimeOffModalCreate_viewer.graphql';

type TimeOffModalCreateQueryWrapperProps = Omit<TimeOffModalCreateProps, 'viewer'> & {
	closeModal: () => void;
};

function TimeOffModalCreateQueryWrapper({...modalProps}: TimeOffModalCreateQueryWrapperProps): JSX.Element {
	return (
		<ForecastQueryRenderer
			key="query-render-time_off_modal_create"
			query={TimeOffModalCreateQuery}
			fetchPolicy={'network-only'}
			modal={true}
			render={(relayProps: RelayProps<TimeOffModalCreate_viewer>) => {
				return <TimeOffModalCreate {...relayProps} {...modalProps} />;
			}}
		/>
	);
}

export default TimeOffModalCreateQueryWrapper;
